import { SelectionModel } from '@angular/cdk/collections';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { startWith, map, Observable } from 'rxjs';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { HeaderComponent } from '../header/header.component';
import { ToastService, ToastType } from '../../services/toast.service';

interface Basement {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-basement',
  templateUrl: './basement.component.html',
  styleUrls: ['./basement.component.css'],
})
export class BasementComponent {
  @ViewChild(HeaderComponent) header: HeaderComponent;

  myListingId: string;
  historyState: any;
  isLoader: boolean = false;

  BelowGradeTotalArea: number = null;
  BelowGradeFinishedArea: number = null;
  BasementType: string = '';
  BasementEntry: string = '';

  roomCtrl = new FormControl('');
  filteredRooms: Observable<string[]>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  Basement: any[] = [];
  allRooms: string[] = ['Basement', 'Bathroom', 'Bedroom', 'Bonus Room', 'Den', 'Dining Room', 'Exercise Room', 'Family Room', 'Game Room', 'Great Room', 'Gym', 'Kitchen', 'Laundry', 'Library', 'Living Room', 'Loft', 'Master Bathroom', 'Media Room', 'Office', 'Sauna', 'Utility Room', 'Workshop'];
  @ViewChild('roomInput') roomInput: ElementRef<HTMLInputElement>;
  basementAreaFlag = false;
  basementDetails: {};

  basementType: Basement[] = [
    { value: 'crawlSpace', viewValue: 'Crawl Space' },
    { value: 'partial', viewValue: 'Partial Basement' },
    { value: 'full', viewValue: 'Full Basement' },
    { value: 'none', viewValue: 'None' },
  ];

  basementEntry: Basement[] = [
    { value: 'interior', viewValue: 'Interior' },
    { value: 'walkOut', viewValue: 'Walk Out' },
    { value: 'walkUp', viewValue: 'Walk Up' },
  ];


  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public toastService: ToastService,
  ) {
    this.filteredRooms = this.roomCtrl.valueChanges.pipe(
      startWith(null),
      map((room: string | null) =>
        room ? this._filter(room) : this.allRooms.slice()
      )
    );
  }

  selection = new SelectionModel<any>(false, []);
  selectedBedroom = new SelectionModel<any>(false, []);
  selectedBathroom = new SelectionModel<any>(false, []);

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.Basement.push(value);
    }
    event.chipInput!.clear();
    this.roomCtrl.setValue(null);
  }

  remove(room: string): void {
    const index = this.Basement.indexOf(room);
    if (index >= 0) {
      this.Basement.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.Basement.push(event.option.viewValue);
    this.Basement = this.removeDuplicates(this.Basement);
    this.roomInput.nativeElement.value = '';
    this.roomCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allRooms.filter((room) =>
      room.toLowerCase().includes(filterValue)
    );
  }

  removeDuplicates(arr): any[] {
    return [...new Set(arr)];
  }

  ngOnInit(): void {
    this.historyState = history.state;
    if (!this.historyState.address) {
      this.router.navigateByUrl('/my-listing');
      return;
    }
    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;
    if (this.historyState && this.historyState.basementDetails) {
      this.Basement = this.historyState.basementDetails.Basement;
      this.BasementType = this.historyState.basementDetails.BasementType;
      this.BasementEntry = this.historyState.basementDetails.BasementEntry;
      this.BelowGradeTotalArea = this.historyState.basementDetails.BelowGradeTotalArea;
      this.BelowGradeFinishedArea = this.historyState.basementDetails.BelowGradeFinishedArea;
    } else {
      if (this.historyState.listingDetails && this.historyState.listingDetails.Basement) {
        this.Basement = this.historyState.listingDetails.Basement.split(',');
      } else {
        this.Basement = [];
      }
      this.BasementType = this.historyState.listingDetails ? this.historyState.listingDetails.BasementType : null;
      this.BasementEntry = this.historyState.listingDetails ? this.historyState.listingDetails.BasementEntry : null;
      this.BelowGradeTotalArea = this.historyState.propertyDetails && this.historyState.propertyDetails.BelowGradeTotalArea ? typeof (this.historyState.propertyDetails.BelowGradeTotalArea) == 'string' ? parseInt(this.historyState.propertyDetails.BelowGradeTotalArea) : this.historyState.propertyDetails.BelowGradeTotalArea : null;
      this.BelowGradeFinishedArea = this.historyState.propertyDetails && this.historyState.propertyDetails.BelowGradeFinishedArea ? typeof (this.historyState.propertyDetails.BelowGradeFinishedArea) == 'string' ? parseInt(this.historyState.propertyDetails.BelowGradeFinishedArea) : this.historyState.propertyDetails.BelowGradeFinishedArea : null;

    }
  }

  back() {
    this.router.navigateByUrl('/parking', {
      state: this.historyState
    });
  }

  saveBasementDetails(submit) {

    if (!this.BelowGradeTotalArea && this.BasementType && (this.BasementType === 'partial' || this.BasementType === 'full')) { //&& (submit == 'submit' )
      this.basementAreaFlag = true;
      this.toastService.toast('Madatory fields are not filled', ToastType.Warning);
    } else {
      this.basementAreaFlag = false;
      this.isLoader = true;
      this.basementDetails = {
        BasementType: this.BasementType,
        BasementEntry: this.BasementEntry,
        BelowGradeTotalArea: this.BelowGradeTotalArea,
        BelowGradeFinishedArea: this.BelowGradeFinishedArea,
        Basement: this.Basement
      }
      this.updateMyListings(submit);
    }
  }

  updateMyListings(submit) {
    if (submit == null || submit == 'skip') {
      if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.3) {
        this.basementDetails["stage"] = 1.3;
      }
      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Basement') <= -1) {
          this.basementDetails["stageName"] = "Basement" + "," + this.historyState.stageName;
        }
      } else {
        this.basementDetails["stageName"] = "Basement" + "," + "Home Details";
      }
    }

    this.basementDetails["updatedDate"] = new Date();

    this.basementDetails = this.filterInputJson(this.basementDetails);

    this.myListingsService.UpdateListing(this.myListingId, this.basementDetails).subscribe(
      {
        next: (res) => {
          if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.3) {
            this.historyState['completedIndex'] = 1.3;
          }
          this.historyState['basementDetails'] = this.basementDetails;
          this.historyState.stageName = this.basementDetails["stageName"];

          this.isLoader = false;
           if (submit == 'skip') {
            this.historyState['completedIndex'] = 1.7;
            this.router.navigateByUrl('/plans', {
              state: this.historyState
            });
          } else {
            this.router.navigateByUrl('/interior', {
              state: this.historyState
            });
          }
        },
        error: (err) => {
          console.log('UpdateListing err!!!!');
          console.log(err);
        }
      }
    );
  }

  skip() {
    this.historyState['completedIndex'] = 1.7;
    this.router.navigateByUrl('/plans', {
      state: this.historyState
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }

}



